import { doctorSpecialties } from './doctor-specialties'
import { nursingSpecialties } from './nursing-specialties'
import { pharmacySpecialties } from './pharmacy-specialties'

export const professionalRoleValues = [
  'doctor',
  'medical_specialist',
  'pharmacist',
  'student',
] as const

export const professionalRoleOptions = [
  { value: 'doctor', label: 'Врач' },
  { value: 'medical_specialist', label: 'Медработник' },
  { value: 'pharmacist', label: 'Фармработник' },
  { value: 'student', label: 'Студент-медик' },
] as const

export type ProfessionalRole = (typeof professionalRoleValues)[number]

export type ProfessionalSpecialtyOption = {
  value: string
  label: string
}

const specialtyOptionsByRole: Record<
  ProfessionalRole,
  ProfessionalSpecialtyOption[]
> = {
  doctor: doctorSpecialties,
  medical_specialist: nursingSpecialties,
  pharmacist: pharmacySpecialties,
  student: [],
}

const customSpecialtyValues = new Set(['other', 'nursing_other'])

export function getSpecialtyOptionsForRole(role: ProfessionalRole) {
  return specialtyOptionsByRole[role]
}

export function getTargetableSpecialtyOptions(
  roles: readonly ProfessionalRole[] = professionalRoleValues,
) {
  const seen = new Set<string>()
  return roles.flatMap((role) =>
    specialtyOptionsByRole[role].flatMap((option) => {
      if (customSpecialtyValues.has(option.value) || seen.has(option.value)) {
        return []
      }
      seen.add(option.value)
      return [{ ...option, role }]
    }),
  )
}

export const targetableSpecialtyValues = getTargetableSpecialtyOptions().map(
  (specialty) => specialty.value,
)
